"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFiltersBar = exports.StyledProductsActionPanelWrapper = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledProductsActionPanelWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};
  width: 100%;
  height: 6.25rem;

  .products-bulk-action-panel {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing(1)};
    flex: 1;
  }

  .products-bulk-enabled-action-panel {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing(1)};
  }

  .product-preview-search-bar {
    flex: 1;
    max-width: 350px;
    margin-right: auto;
  }

  .product-preview-divider {
    height: 17px;
    flex: 0 0 2px;
    padding-left: ${({ theme }) => theme.spacing(1)};
    margin: 0 ${({ theme }) => theme.spacing(1)};
  }

  .MuiIconButton-root:not(.Mui-disabled) {
    color: ${ui_components_1.baseColors.primaryBlueMed400};
  }

  .MuiIconButton-root.Mui-disabled {
    cursor: not-allowed;
    pointer-events: all;
  }
`;
exports.StyledFiltersBar = (0, styled_components_1.default)(ui_components_1.DataGridFilterBar) `
  padding: 0;
`;
